(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dmshop-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.dm-home').forEach(function(home){
  home.querySelectorAll('[data-dm-open]').forEach(function(button){
    button.addEventListener('click',function(){
      var dialog=document.getElementById(button.dataset.dmOpen);
      if(dialog){dialog.showModal();}
    });
  });
  home.querySelectorAll('.dm-dialog').forEach(function(dialog){
    dialog.querySelectorAll('[data-dm-close]').forEach(function(button){
      button.addEventListener('click',function(){dialog.close();});
    });
    dialog.addEventListener('click',function(event){if(event.target===dialog){var r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom){dialog.close();}}});
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
